import { useCallback } from "react";
/**
 * A custom hook that provides some helpful functions to enhance video security and prevent student users from
 * manipulating videos in order to game the learning system. In IPS-1418, we found that students were able to
 * loop videos using the video context menu, allowing them to keep a user session open and gain extra active time
 * in the application. As other video-related security issues arise, this hook can be extended to include
 * additional security measures.
 *
 * @returns An object containing video security utility functions:
 * - `preventVideoLooping`: A function that disables looping on all video elements in the document.
 *
 * @example
 * ```tsx
 * const { preventVideoLooping } = useVideoSecurity();
 *
 * // Call this to prevent any video from looping
 * preventVideoLooping();
 * ```
 */
export default function useVideoSecurity() {
    var preventVideoLooping = useCallback(function () {
        var videoElements = document.querySelectorAll("video");
        videoElements.forEach(function (video) {
            if (video === null || video === void 0 ? void 0 : video.loop) {
                // eslint-disable-next-line no-param-reassign
                video.loop = false;
            }
        });
    }, []);
    return { preventVideoLooping: preventVideoLooping };
}
